import { render, staticRenderFns } from "./DocumentToValidateList.vue?vue&type=template&id=69502c85&"
import script from "./DocumentToValidateList.vue?vue&type=script&lang=js&"
export * from "./DocumentToValidateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69502c85')) {
      api.createRecord('69502c85', component.options)
    } else {
      api.reload('69502c85', component.options)
    }
    module.hot.accept("./DocumentToValidateList.vue?vue&type=template&id=69502c85&", function () {
      api.rerender('69502c85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/DocumentToValidateList.vue"
export default component.exports